export default __webpack_public_path__ + "static/media/iphone-13-pro-max.9e3d14b9.webp";